module.exports = "/images/manila-times.png?8c3e3f182f0cda0508c9a5bb1e1129dc";